import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'cp-new-receiving',
    templateUrl: './new-receiving.component.html',
    styleUrls: ['./new-receiving.component.scss'],
    standalone: false
})
export class NewReceivingComponent implements OnInit {

  constructor() { }
	@Output() titleChild = new EventEmitter<string>();

  ngOnInit() {
	  this.titleChild.emit('New Receiving');
  }
	
}